$(document).ready(function (e) {

    let $body = $('body');

    if ($('.kanban').length) {
        let total_height = $(document).height(),
            header_height = $('.table-heading-row').innerHeight(),
            remaining_height = total_height - 160 - header_height;

        $('.kanban').css({'height': remaining_height + 'px'});
        $('.category').css({'height': remaining_height + 'px'});
        $('.records').css({'height': remaining_height + 'px'});
    }

    $body.on('click', '.cancel-kanban-save', function (e) {
        let table_id = $(this).data('table-id');
        window.location = `/browse/${table_id}`;
    });

    $body.on('click', '.save-kanban', function (e) {
        let table_id = $(this).data('table-id'),
            error = false,
            payload = [],
            columns = [],
            view_name = $('#view-name').val(),
            categorize_by = $('#categorize-by').val(),
            aggregate_by = $('#aggregate-by').val(),
            $selected_columns = $('.selected-columns').find('.column'),
            colorize = $('input[name="colorize"]:checked').val();

        console.log(colorize);

        $selected_columns.each((i, $column) => {
            columns.push($($column).data('field-id'));
        });

        if (!view_name.length) {
            alert('Please enter view name');
            return;
        }

        if (!categorize_by.length) {
            alert('Select categorize by field');
            return;
        }
        //
        // if (!aggregate_by.length) {
        //     alert('Select aggregate by field');
        //     return;
        // }

        if (!$selected_columns.length) {
            alert('Select columns for filter');
            return;
        }

        if (!error) {
            $.ajax({
                method: 'POST',
                url: `/kanban/${table_id}`,
                data: {
                    payload: payload,
                    title: view_name,
                    columns: columns,
                    aggregate_by: aggregate_by,
                    categorize_by: categorize_by,
                    colorize: colorize
                },
                success: function (res) {
                    if (res) {
                        window.location = `/browse/${table_id}/kanban`;
                    }
                }
            })
        }
    });

    $body.on('click', '.update-kanban', function (e) {
        let table_id = $(this).data('table-id'),
            id = $(this).data('id'),
            error = false,
            payload = [],
            columns = [],
            view_name = $('#view-name').val(),
            categorize_by = $('#categorize-by').val(),
            aggregate_by = $('#aggregate-by').val(),
            $selected_columns = $('.selected-columns').find('.column'),
            colorize = $('input[name="colorize"]:checked').val();


        $selected_columns.each((i, $column) => {
            columns.push($($column).data('field-id'));
        });

        if (!view_name.length) {
            alert('Please enter view name');
            return;
        }

        if (!categorize_by.length) {
            alert('Select categorize by field');
            return;
        }

        // if (!aggregate_by.length) {
        //     alert('Select aggregate by field');
        //     return;
        // }

        if (!$selected_columns.length) {
            alert('Select columns for filter');
            return;
        }

        if (!error) {
            $.ajax({
                method: 'POST',
                url: `/kanban/${table_id}/update`,
                data: {
                    id: id,
                    payload: payload,
                    title: view_name,
                    columns: columns,
                    aggregate_by: aggregate_by,
                    categorize_by: categorize_by,
                    colorize: colorize
                },
                success: function (res) {
                    if (res) {
                        window.location = `/browse/${table_id}/kanban`;
                    }
                }
            })
        }
    });

    let $prevCategoryAggregate;

    $('.kanban .category').each(function (index, $category) {
        loadKanbanRecords($($category));
    });

    $('.kanban .category .records').on('scroll', function (e) {
        let $category = $(this).parents('.category');
        if ($(this).scrollTop() + $(this).innerHeight() + 50 >= $(this)[0].scrollHeight) {
            loadKanbanRecords($($category));
        }
    });

    function loadKanbanRecords($category) {
        var query = window.location.search,
            table_id = $($category).parents('.kanban').attr('data-table'),
            category = $($category).attr('data-category'),
            skip = $($category).find('.records').find('.record').length;

        if(!$category.hasClass('is-loading')){

            $category.addClass('is-loading');

            $.ajax({
                type: 'GET',
                url: '/lazy-kanban/' + table_id + '/kanban' + query,
                data: {
                    category,
                    skip
                },
                success: function (res) {
                    if (res) {
                        $($category).find('.records').append(res);

                        $(".record").draggable({
                            revert: "invalid",
                            containment: "document",
                            cursor: "move",
                            helper: "clone",
                            zIndex: 1000,
                            start: function (event, ui) {
                                $prevCategoryAggregate = $(ui.helper).parents('.category').find('.aggregate-value');
                            },
                        });

                        $('.records').droppable({
                            accept: ".record",
                            greedy: true,
                            drop: function (event, ui) {

                                console.log(event);

                                let categorize_field = $(this).attr('data-categorize-field'),
                                    category = $(this).attr('data-category'),
                                    table_id = $('.kanban').attr('data-table'),
                                    kanban_id = $('.kanban').attr('data-kanban'),
                                    record = $(ui.draggable).attr('data-id'),
                                    option_field = $(ui.draggable).find('.cat-by');

                                if (option_field.length) {
                                    let options = JSON.parse($(option_field).attr('data-values')),
                                        colors = JSON.parse($(option_field).attr('data-colors')),
                                        color = colors[options.indexOf(category)];

                                    $(option_field).find('span').css('background-color', color);
                                    $(option_field).find('span').text(category);
                                }


                                $(this).append(ui.draggable.removeAttr('style'));

                                $.ajax({
                                    type: 'POST',
                                    url: '/kanban/category',
                                    data: {
                                        record,
                                        categorize_field,
                                        category,
                                        table_id,
                                        kanban_id
                                    },
                                    success: (res) => {
                                        $(this).parents('.category').find('.aggregate-value').text(res[0]);
                                        $($prevCategoryAggregate).text(res[1]);
                                    }
                                })
                            }
                        });

                        $category.removeClass('is-loading');
                    }
                }
            });
        }
    }
});